import { useState } from 'react';

import { KeenSliderHooks, KeenSliderInstance, KeenSliderOptions } from 'keen-slider';
import { KeenSliderPlugin, useKeenSlider } from 'keen-slider/react';

import 'keen-slider/keen-slider.min.css';

const ResizePlugin: KeenSliderPlugin = (slider) => {
  const observer = new ResizeObserver(() => {
    slider.update();
  });

  slider.on('created', () => {
    observer.observe(slider.container);
  });
  slider.on('destroyed', () => {
    observer.unobserve(slider.container);
  });
};

export const useSlider = (
  options?: KeenSliderOptions,
): [
  (node: HTMLDivElement | HTMLUListElement | null) => void,
  React.MutableRefObject<KeenSliderInstance<{}, {}, KeenSliderHooks> | null>,
  boolean,
  number,
] => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement | HTMLUListElement>(
    {
      initial: 0,
      loop: true,
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
      ...options,
    },
    [ResizePlugin],
  );

  return [sliderRef, instanceRef, loaded, currentSlide];
};

export default useSlider;
